import { CrudList } from '../shared/CrudPage';
import { expenseService } from '@kss/api';
import type { Expense, ExpenseCreate, ExpenseFilter } from '@kss/api';
import { NameCell } from '../../hooks/useNameMaps';

export default function AllExpenses() {
  return (
    <CrudList<Expense, ExpenseCreate, ExpenseFilter>
      title="All expenses" newLabel="New expense" service={expenseService}
      idKey="expenseId" labelKey="description" basePath="/panel/expenses"
      // Newest expense on top — order-like grid. Ref: ORDER_WORKFLOW_AUDIT #6.
      initialSortStatus={{ columnAccessor: 'expenseDate', direction: 'desc' }}
      columns={[
        // Live API columns: expenseNumber, expenseDate,
        // categoryAccountId (GUID), vendor, description, amount.
        // The legacy `category` accessor (free-text string) was
        // removed when the model migrated to a chart-of-accounts FK.
        {
          accessor: 'expenseNumber',
          title: 'Number',
          sortable: true,
          filterable: true,
          width: 140,
          render: (r) => (r as Expense & { expenseNumber?: string }).expenseNumber || '—',
        },
        { accessor: 'expenseDate', title: 'Date', sortable: true, render: (r) => r.expenseDate ? new Date(r.expenseDate).toLocaleDateString() : '—' },
        {
          accessor: 'categoryAccountId',
          title: 'Category',
          render: (r) => (
            <NameCell
              kind="account"
              id={(r as Expense & { categoryAccountId?: string }).categoryAccountId}
            />
          ),
        },
        { accessor: 'vendor', title: 'Vendor', sortable: true, filterable: true, render: (r) => r.vendor || '—' },
        { accessor: 'description', title: 'Description', sortable: true, filterable: true, render: (r) => r.description || '—' },
        { accessor: 'amount', title: 'Amount (₹)', sortable: true, textAlign: 'right', render: (r) => Number(r.amount ?? 0).toLocaleString('en-IN') },
      ]}
    />
  );
}
